import { render } from "./ShareholderIndividual.vue?vue&type=template&id=00819dbc&scoped=true&ts=true"
import script from "./ShareholderIndividual.vue?vue&type=script&lang=ts"
export * from "./ShareholderIndividual.vue?vue&type=script&lang=ts"

import "./ShareholderIndividual.vue?vue&type=style&index=0&id=00819dbc&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00819dbc"]])

export default __exports__